import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import PublicMarketplace from "./pages/PublicMarketplace";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PortalDashboard from "./pages/PortalDashboard";
import PortalRecordsPage from "./pages/PortalRecordsPage";
import SellerWorkspace from "./pages/SellerWorkspace";
import BusinessWorkspace from "./pages/BusinessWorkspace";
import ProductCatalogue from "./pages/ProductCatalogue";
import ProductDetail from "./pages/ProductDetail";
import CategoryProducts from "./pages/CategoryProducts";
import EnquiriesWorkspace from "./pages/EnquiriesWorkspace";
import OrdersWorkspace from "./pages/OrdersWorkspace";
import CategoryManagement from "./pages/CategoryManagement";
import TransporterWorkspace from "./pages/TransporterWorkspace";
import TransporterServices from "./pages/TransporterServices";
import SearchResults from "./pages/SearchResults";
import RequestQuote from "./pages/RequestQuote";
import PublicSellers from "./pages/PublicSellers";
import BusinessSolutions from "./pages/BusinessSolutions";
import PublicAI from "./pages/PublicAI";
import VisualSearch from "./pages/VisualSearch";
import FinanceWorkspace from "./pages/FinanceWorkspace";
import AIWorkspace from "./pages/AIWorkspace";
import NotificationCentre from "./pages/NotificationCentre";
import ReviewsWorkspace from "./pages/ReviewsWorkspace";
import PaymentReturn from "./pages/PaymentReturn";
import StaticContentPage from "./pages/StaticContentPage";
import ScrollToTop from "./components/ScrollToTop";

function ProtectedRoute({ children }) {
  const { isAuthenticated, booting } = useAuth();
  const location = useLocation();
  if (booting) return <div className="portal-boot-screen">Opening TAZY CART...</div>;
  const next = `${location.pathname}${location.search || ""}`;
  return isAuthenticated ? children : <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
}

function ProtectedPage({ type }) {
  return (
    <ProtectedRoute>
      <PortalRecordsPage type={type} />
    </ProtectedRoute>
  );
}

function ProtectedComponent({ children }) {
  return <ProtectedRoute>{children}</ProtectedRoute>;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<PublicMarketplace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/products/:slug" element={<ProductDetail />} />
      <Route path="/categories/:code" element={<CategoryProducts />} />
      <Route path="/transporters" element={<TransporterServices />} />
      <Route path="/search" element={<SearchResults />} />
      <Route path="/request" element={<RequestQuote />} />
      <Route path="/sellers" element={<PublicSellers />} />
      <Route path="/business-solutions" element={<BusinessSolutions />} />
      <Route path="/ai" element={<PublicAI />} />
      <Route path="/scan" element={<VisualSearch />} />

      <Route path="/about" element={<StaticContentPage slug="about" />} />
      <Route path="/marketplace-rules" element={<StaticContentPage slug="marketplace-rules" />} />
      <Route path="/seller-verification" element={<StaticContentPage slug="seller-verification" />} />
      <Route path="/order-protection" element={<StaticContentPage slug="order-protection" />} />
      <Route path="/dispute-support" element={<StaticContentPage slug="dispute-support" />} />
      <Route path="/buyer-help" element={<StaticContentPage slug="buyer-help" />} />
      <Route path="/seller-help" element={<StaticContentPage slug="seller-help" />} />
      <Route path="/courier-help" element={<StaticContentPage slug="courier-help" />} />
      <Route path="/contact" element={<StaticContentPage slug="contact" />} />
      <Route path="/privacy" element={<StaticContentPage slug="privacy" />} />
      <Route path="/terms" element={<StaticContentPage slug="terms" />} />
      <Route path="/payment/return" element={<ProtectedComponent><PaymentReturn /></ProtectedComponent>} />
      <Route path="/payment/return/" element={<ProtectedComponent><PaymentReturn /></ProtectedComponent>} />
      <Route path="/portal" element={<ProtectedComponent><PortalDashboard /></ProtectedComponent>} />
      <Route path="/portal/store" element={<ProtectedComponent><SellerWorkspace /></ProtectedComponent>} />
      <Route path="/portal/business" element={<ProtectedComponent><BusinessWorkspace /></ProtectedComponent>} />
      <Route path="/portal/products" element={<ProtectedComponent><ProductCatalogue /></ProtectedComponent>} />
      <Route path="/portal/sellers" element={<ProtectedPage type="sellers" />} />
      <Route path="/portal/businesses" element={<ProtectedPage type="businesses" />} />
      <Route path="/portal/buyers" element={<ProtectedPage type="buyers" />} />
      <Route path="/portal/transporters" element={<ProtectedPage type="transporters" />} />
      <Route path="/portal/transport" element={<ProtectedComponent><TransporterWorkspace /></ProtectedComponent>} />
      <Route path="/portal/documents" element={<ProtectedPage type="documents" />} />
      <Route path="/portal/categories" element={<ProtectedComponent><CategoryManagement /></ProtectedComponent>} />
      <Route path="/portal/enquiries" element={<ProtectedComponent><EnquiriesWorkspace /></ProtectedComponent>} />
      <Route path="/portal/orders" element={<ProtectedComponent><OrdersWorkspace /></ProtectedComponent>} />
      <Route path="/portal/deliveries" element={<ProtectedPage type="deliveries" />} />
      <Route path="/portal/subscriptions" element={<ProtectedComponent><FinanceWorkspace /></ProtectedComponent>} />
      <Route path="/portal/finance" element={<ProtectedComponent><FinanceWorkspace /></ProtectedComponent>} />
      <Route path="/portal/ai" element={<ProtectedComponent><AIWorkspace /></ProtectedComponent>} />
      <Route path="/portal/notifications" element={<ProtectedComponent><NotificationCentre /></ProtectedComponent>} />
      <Route path="/portal/reviews" element={<ProtectedComponent><ReviewsWorkspace /></ProtectedComponent>} />
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
